import { createLogger, getCurrentLogLevel } from "@/utils/logger";

import type { DocumentModel } from "@/models/DocumentModel";

/**
 * Find and log nodes without parent. It is used in DocumentModel right before the end of the transaction.
 * In test mode it will raise error to fail the test if such nodes are found.
 */
export function logOrphanNodes(doc: DocumentModel) {
  const logger = createLogger("DocumentModel");
  const isTestEnv = process.env.NODE_ENV === "test";
  if (getCurrentLogLevel() === "DEBUG" || isTestEnv) {
    const orphanNodes = [...doc.nodes.values()].filter((n) => {
      if (n.type === "text" || n.type === "graph") return false;
      return !n.parent?.childrenIds?.includes(n.id);
    });
    if (orphanNodes.length > 0) {
      if (isTestEnv) {
        const message = [
          "Orphan nodes found:",
          ...orphanNodes.map((node) => {
            return [node, ...node.ancestors]
              .reverse()
              .flatMap((n, i) => {
                const indent = "  ".repeat(i);
                return n === node && node.parent
                  ? [
                      `${indent}<!-- actual children: [${node.parent.childrenIds.join(", ")}] -->`,
                      `${indent}<${n.type} id="${n.id}">`,
                    ]
                  : `${indent}<${n.type} id="${n.id}">`;
              })
              .join("\n");
          }),
        ].join("\n\n");
        throw new Error(message);
      } else {
        logger.debug("Orphan nodes", orphanNodes);
      }
    }
  }
}
